import { render } from "./InformacionLaboral.vue?vue&type=template&id=df810c5a"
import script from "./InformacionLaboral.vue?vue&type=script&lang=js"
export * from "./InformacionLaboral.vue?vue&type=script&lang=js"

import "./InformacionLaboral.vue?vue&type=style&index=0&id=df810c5a&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__